import { COUNTRIES } from '@config/constants'
import { dynamicImport, insertIf } from '@core/helpers'
import { ROUTES } from '@router'

// buyback routes are only eligible for certain countries
const buybackRoutes = [
  {
    path: '/buyback/:pageName',
    component: () => dynamicImport(import('./Landing')),
    name: ROUTES.CMS.BUYBACK,
  },
  {
    path: '/buyback/:pageName/:pageCategory',
    component: () => dynamicImport(import('./Landing')),
    name: ROUTES.CMS.BUYBACK_CATEGORY,
  },
]
export default ({ country }) => {
  const shouldAddBuybackRoutes = [
    COUNTRIES.FR,
    COUNTRIES.DE,
    COUNTRIES.US,
  ].includes(country)

  return [
    {
      path: '/b/:pageName',
      component: () => dynamicImport(import('./Landing')),
      name: ROUTES.CMS.BRAND_STORE,
    },
    {
      path: '/b/:pageName/:pageCategory',
      component: () => dynamicImport(import('./Landing')),
      name: ROUTES.CMS.BRAND_STORE_CATEGORY,
    },
    {
      path: '/e/:pageName',
      component: () => dynamicImport(import('./Landing')),
      name: ROUTES.CMS.EVENT,
    },
    {
      path: '/business/:pageName',
      component: () => dynamicImport(import('./Landing')),
      name: ROUTES.CMS.BUSINESS,
    },
    ...insertIf(shouldAddBuybackRoutes, buybackRoutes),
  ]
}
